import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { onDeepLink, toInAppPath } from './push'

/**
 * Drains the push deep-link queue into the router.
 *
 * `enabled` is not a convenience. While it is false no listener is registered,
 * so `offerDeepLink` keeps the payload parked — which is what makes a tap that
 * arrives during a cold start on a logged-out app survive the login instead of
 * being spent on the login screen.
 *
 * It lives here rather than in a component inside AppShell because AppShell is
 * not rendered when there is no auth, so a component there would never mount for
 * exactly the case this exists to handle. It would look fine in testing, because
 * you are always already logged in when you test it.
 */
export function usePushDeepLink(enabled: boolean): void {
  const navigate = useNavigate()

  useEffect(() => {
    if (!enabled) return

    return onDeepLink((url) => {
      const path = toInAppPath(url, window.location.origin)
      if (!path) {
        console.warn('[push] refusing off-origin deep link', url)
        return
      }
      // `replace`, so Back does not return to the ?source=push URL and re-run
      // the drain.
      navigate(path, { replace: true })
    })
  }, [enabled, navigate])
}
